import React, { Fragment, useContext } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { Toast } from "../../components/ui/toast/Toast";
import AnonLoginModal from "../../features/auth/AnonLoginModal";

import AuthContext from "../../store/context/auth-context";
import ToastContext from "../../store/context/toast-context";

import FooterFour from "./components/footers/footerFourth/FooterFourth";
import FooterSecond from "./components/footers/footerSecond/FooterSecond";
import FooterThird from "./components/footers/footerThird/FooterThird";
import Headers from "./components/headers";
import ProductAddedModal from "../../features/productDetail/components/productDetails/components/ProductDetailActions/components/productAddedModal/ProductAddedModal";

const Layout = (props) => {
  const location = useLocation();
  const authCtx = useContext(AuthContext);
  const toastCtx = useContext(ToastContext);

  const isLandingPage = location.pathname === "/";
  const isLoggedIn = authCtx.isLoggedIn;
  const isShown = useSelector((state) => state.ui.authPopUpIsVisible);
  const isLoading = useSelector((state) => state.ui.loadingIsVisible);

  return (
    <Fragment>
      {!isLoggedIn && isShown && <AnonLoginModal />}
      {isLoggedIn && isLoading && <ProductAddedModal />}

      {toastCtx.allToasts.map((toast) => (
        <Toast key={toast.id} close={() => toastCtx.close(toast.id)}>
          {toast.content}
        </Toast>
      ))}

      <Headers />
      <main>{props.children}</main>
      <footer>
        <FooterSecond />
        {isLandingPage && <FooterThird />}
        <FooterFour />
      </footer>
    </Fragment>
  );
};

export default Layout;
